import { createSlice } from '@reduxjs/toolkit';

const errorMessage = (payload) =>
  typeof payload === 'string' ? payload : payload?.message || 'Request failed';

export const notificationFrameworkSlice = createSlice({
  name: 'notificationFramework',
  initialState: {
    registry: {
      notifications: [],
      exclusions: {},
      protectedRitual: null,
      loading: false,
      error: null,
    },
    ledger: { items: [], nextCursor: null, loading: false, error: null },
    summary: { data: null, loading: false, error: null },
  },
  reducers: {
    getFrameworkRegistryAction: (state) => {
      state.registry.loading = true;
      state.registry.error = null;
    },
    getFrameworkRegistrySuccess: (state, action) => {
      state.registry.notifications = action.payload?.notifications || [];
      state.registry.exclusions = action.payload?.exclusions || {};
      state.registry.protectedRitual = action.payload?.protected_ritual || null;
      state.registry.loading = false;
    },
    getFrameworkRegistryFailure: (state, action) => {
      state.registry.loading = false;
      state.registry.error = errorMessage(action.payload);
    },
    getFrameworkEventsAction: (state) => {
      state.ledger.loading = true;
      state.ledger.error = null;
    },
    getFrameworkEventsSuccess: (state, action) => {
      state.ledger.items = action.payload?.items || [];
      state.ledger.nextCursor = action.payload?.next_cursor || null;
      state.ledger.loading = false;
    },
    getFrameworkEventsFailure: (state, action) => {
      // The view already shows the new filters/page; stale rows under them would
      // read as results for the query that failed.
      state.ledger.items = [];
      state.ledger.nextCursor = null;
      state.ledger.loading = false;
      state.ledger.error = errorMessage(action.payload);
    },
    getFrameworkSummaryAction: (state) => {
      state.summary.loading = true;
      state.summary.error = null;
    },
    getFrameworkSummarySuccess: (state, action) => {
      state.summary.data = action.payload || null;
      state.summary.loading = false;
    },
    getFrameworkSummaryFailure: (state, action) => {
      state.summary.data = null; // never show one window's totals under another's label
      state.summary.loading = false;
      state.summary.error = errorMessage(action.payload);
    },
  },
});

export const {
  getFrameworkRegistryAction,
  getFrameworkRegistrySuccess,
  getFrameworkRegistryFailure,
  getFrameworkEventsAction,
  getFrameworkEventsSuccess,
  getFrameworkEventsFailure,
  getFrameworkSummaryAction,
  getFrameworkSummarySuccess,
  getFrameworkSummaryFailure,
} = notificationFrameworkSlice.actions;

export default notificationFrameworkSlice.reducer;
